import React from 'react';
import { Button } from '@mui/material';

function BorderedButton({
  children,
  onClick,
  type = 'button',
  disabled = false,
  fullWidth = false,
  startIcon,
  endIcon,
  sx = {},
  ...rest
}) {
  return (
    <Button
      type={type}
      onClick={onClick}
      disabled={disabled}
      fullWidth={fullWidth}
      startIcon={startIcon}
      endIcon={endIcon}
      variant="outlined"
      sx={{
        color: 'white',
        borderColor: 'rgba(255, 255, 255, 0.2)',
        '&:hover': { borderColor: '#F6911D', color: '#F6911D' },
        '&:disabled': {
          borderColor: 'rgba(255, 255, 255, 0.1)',
          color: 'rgba(255, 255, 255, 0.3)',
        },
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Button>
  );
}

export default BorderedButton;
